import RemoveRepository from "@domain/repositories/RemoveRepository";
import showToast from "@helpers/showToast";
import { HttpClient } from "@data/api/HttpClient";
import { RemoveClient } from "@domain/models/RemoveClient";
import { Report } from "@domain/models/Report";

export class HttpRemoveRepository implements RemoveRepository {
  private readonly baseUrl = `${process.env.REACT_APP_API_URL}/remove`;

  constructor(private readonly httpClient: HttpClient) {}

  async getRemoveHistory() {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/history`,
      })
      .then((response) => {
        return response.data;
      });
  }

  async getRemoveHistoryClients(removeHistoryId: string) {
    return this.httpClient
      .request({
        method: "GET",
        url: `${this.baseUrl}/history/${removeHistoryId}/clients`,
      })
      .then((response) => {
        return response.data;
      });
  }

  async validateRemove(clients: RemoveClient[]) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/clients/validate`,
        body: JSON.stringify({ clients }),
      })
      .then((response) => {
        showToast(response.message, "warn");
        return response.data;
      });
  }

  async removeClients(
    result: Report["result"],
    description: string,
    selectedClients: RemoveClient[],
    notSelectedClients: RemoveClient[]
  ) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/clients`,
        body: JSON.stringify({ result, description, selectedClients, notSelectedClients }),
      })
      .then((response) => {
        if (response.message.includes("sucesso")) {
          showToast(response.message, "success");
        } else {
          showToast(response.message, "warn");
        }

        return response.data;
      });
  }

  async removeOldClients() {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/clients/old`,
      })
      .then((response) => {
        if (response.message.includes("sucesso")) {
          showToast(response.message, "success");
        } else {
          showToast(response.message, "warn");
        }

        return response.data;
      });
  }

  async undoRemoveClients(removeHistoryId: string) {
    return this.httpClient
      .request({
        method: "POST",
        url: `${this.baseUrl}/history/${removeHistoryId}/undo`,
      })
      .then((response) => {
        if (response.message.includes("sucesso")) {
          showToast(response.message, "success");
        } else {
          showToast(response.message, "warn");
        }

        return response.data;
      });
  }
}
